import type * as Types from '../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchBarUserSearchCreateMutationVariables = Types.Exact<{
  input: Types.UserSearchCreateInput;
}>;


export type SearchBarUserSearchCreateMutation = { __typename?: 'Mutation', userSearchCreate?: { __typename?: 'UserSearch', id: string, searchString?: string | null, searchUrl?: string | null } | null };

export const SearchBarUserSearchCreateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"searchBarUserSearchCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSearchCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSearchCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"searchString"}},{"kind":"Field","name":{"kind":"Name","value":"searchUrl"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchBarUserSearchCreateGQL extends Apollo.Mutation<SearchBarUserSearchCreateMutation, SearchBarUserSearchCreateMutationVariables> {
    document = SearchBarUserSearchCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }